<template>
  <div >
    <div class="box-login">
      <h1 class="is-size-5" style="text-align">
        Para ter acesso ao nosso sistema, pedimos que realize o login.
      </h1>
      <p>
        <small>Utilize o seu CPF para 'acesso' <br />e a sua senha(feita no cadastro).</small>
      </p>
      <form label-width="120px" @keyup.enter='submit'>
        <el-row class="row-login">
          <el-col :span="24">
           <el-input prefix-icon="fas fa-user" placeholder="CPF" v-model="username"></el-input>
          </el-col>
        </el-row>
        <el-row class="row-login">
          <el-col :span="24">
           <el-input type="password" prefix-icon="fas fa-user" placeholder="Usuário" v-model="password"></el-input>
          </el-col>
        </el-row>
        <el-row class="row-login">
          <el-col :span="24">
            <el-button type="text" size="small" @click='$router.push("/p/recuperar-acesso")'>Esqueci a senha</el-button>
            <el-button type="success" @click='submit'>Entrar</el-button>
          </el-col>
        </el-row>
      </form>
      <small>
      <p>
        Caso não tenha cadastro, <el-button type="text" @click="() => $router.push('/p/cadastro')" >Cadastre-se</el-button>.
      </p>
    </small>

    </div>
  </div>
</template>

<script>
import Store from '@/store'
export default {
  data() {
      return {
          username: '',
          password: '',
        
      }
  },
  methods:{
    handleClick() {
        console.log('click');
    },
    submit(e){
      e.preventDefault()
      if(this.username.length > 4 && this.password.length > 2)
      {
        Store.dispatch('session/login', {
          username: this.username, 
          password: this.password
        });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .box-login{
  padding:25px;
  background: #FFF;
  width: 400px;
  margin:auto;
  min-height:100px;

 }
 .row-login{
  margin:20px;
 }
</style>
